import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { CommandPaletteProvider } from '@/shared/components/CommandPalette';
import { Outlet } from 'react-router-dom';

/** Root layout with global error boundary and command palette (requires router context). */
export function RootLayout() {
  return (
    <ErrorBoundary fallbackTitle="Application error">
      <CommandPaletteProvider>
        <Outlet />
      </CommandPaletteProvider>
    </ErrorBoundary>
  );
}
